<template>
<div class="rewards">
    <div class="top-section w-full h-full mb-4">
        <div class="flex items-center justify-between px-4 py-4">
            <div class="sm:flex sm:justify-between w-full items-start md:block left text-center sm:text-left">
                <h5 class="text-2xl md:text-4xl font-bold mb-5">
                    {{ activeLesson }}
                </h5>
            </div>
            <div class=" md:block right">
                <vue-ellipse-progress :size="100" :progress="course.progress ? parseInt(course.progress) : 0" animation="reverse 700 400">
                    <span slot="legend-value">%</span>
                </vue-ellipse-progress>
            </div>
        </div>
    </div>
    <router-view @current-lesson="activeLesson = $event" />
</div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import isEmpty from "lodash.isempty";

    export default {
    name: "lesson-index",
    data() {
        return {
            activeLesson: null,
            courses: this.$store.state.learner.courses,
            active_course: ''
        };
    },
    components: {
        LmsButton: () => import("@/components/general/button"),
        lcontainer: () => import("@/components/general/container"),
    },
    methods: {
      ...mapMutations(["updateLoader"]),
        ...mapActions(["fetchEnrolledCourse","fetchLearnerModules","fetchLearnerCourseProgress"]),
    },
    computed: {
      ...mapGetters(["getLearnerModules"]),
          course() {
            return this.courses[this.$route.params.course_id];
    
        },
    },
    async created() {
      this.updateLoader(true);
      //let current_course_id = typeof this.$route.params.course_id === "undefined" || !this.$route.params.course_id ? this.active_course : this.$route.params.course_id;
      let current_course_id = this.$route.params.course_id;
        
        this.course.progress = await this.fetchLearnerCourseProgress({
            course_id: current_course_id,
        })

        let activeCourse = this.courses[current_course_id];

        await this.fetchLearnerModules({id:current_course_id})
        if (
            activeCourse.course_prerequisite &&
            !isEmpty(activeCourse.course_prerequisite) &&
            !activeCourse.course_prerequisite.completed_prerequisite
        )
        {
            await this.$swal({
                title: `This Course has a Prerequiste.`,
                text: `You need to take the ${activeCourse.course_prerequisite.prerequiste.title} course before you take this course`,
                cancelButtonText: "Back to My Courses",
                confirmButtonText: "Take Prerequisite",
                showCancelButton: true,
            }).then((res) => {
                if (res.isConfirmed) {
                    this.$router.push({
                        name: "learner-single-course",
                        params: {
                            id: activeCourse.course_prerequisite.prerequiste.id
                        },
                    });
                } else {
                    this.$router.push({
                        name: "learner-enrolled-courses"
                    });
                }
            });
        } else {
            if (!this.$route.params.lesson_id) {
               let activeModules = this.getLearnerModules;
                let sortedModules = activeModules.sort((a, b) => {
                    return a.module_number - b.module_number;
                });

                let allLessons = [];
                for (let i = 0; i < sortedModules.length; i++) {
                    let lessons = sortedModules[i].lessons; //Get all lessons oin module
                    let sortedLessons = lessons.sort((a, b) => {
                        return a.lesson_number - b.lesson_number;
                    });
                    allLessons.push(...sortedLessons);
                }

                const found = allLessons.find((lesson) => {
                    return !lesson.completed;
                });
                // console.log(found)
                this.updateLoader(false)
                //

                if (typeof found != "undefined") {
                    return this.$router.replace({
                        name: "learner-lesson",
                        params: {
                            lesson_id: found.id,
                        },
                    });
                } else {
                    let last_lesson = allLessons[allLessons.length - 1];
                    await this.$router.replace({
                        name: "learner-lesson",
                        params: {
                            lesson_id: last_lesson.id,
                        },
                    });
                }
            } else {
                this.$router
                    .replace({
                        name: "learner-lesson",
                        params: {
                            lesson_id: this.$route.params.lesson_id,
                        },
                    })
                    .catch(() => {});
            }
        }

    },
    mounted() {
        //console.log(this.$route.params.course_id);
        this.active_course = this.$route.params.course_id;
        // if (localStorage.active_course) {
        //     console.log("storage active")
        //     console.log(localStorage.active_course);
        //     this.active_course = localStorage.active_course;
        // }
    },
    watch: {
        active_course(newActiveCourse) {
            localStorage.active_course = newActiveCourse;
        }
    },
};
</script>

<style lang="scss">
.rewards {
    .top-section {
        background: linear-gradient(61deg, color(lms-tenant), #fff 100%);

        h5 {
            color: #fff !important;
        }

        button {
            color: color(lms-tenant) !important;
        }
    }

    .home,
    .details {
        background-color: #fff;
    }

    .create {
        background-color: #fff;

        .import {
            color: color(lms-tenant);
        }
    }
}

.page-heading {
    color: color(lms-tenant);
}
</style>
